<template lang="pug">
.v-form-message.form-message(v-if="message")
	img.form-message__icon(v-if="message.icon" :src="message.icon")
	.form-message__title(v-if="message.title") {{message.title}}
	.form-message__text(v-if="message.text") {{message.text}}
	v-action.btn.form-message__action(v-if="message.action" :action="message.action" @click="handlerAction(action)")
</template>

<script>

export default {

	emits: [
			'action'
	],

	props: {
		message: {
			type: Object,
			default: null
		}
	},

	methods: {
		handlerAction(action) {
			this.$emit('action', action)
		}
	}
}

</script>